import features from 'src/replicant/ruleset/features';
import { Container, Sprite, Texture } from '../../../odie';

import { ParcelsBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { user } from 'src/StateObserver';

const manifest = {
  enabled: 'parcels/block.parcels.png',
  disabled: 'parcels/block.parcels.disabled.png',
  fx: 'parcels/block.parcels.parachute.png',
};

const cratesManifest = {
  enabled: 'parcels/block.crates.png',
  disabled: 'parcels/block.crates.disabled.png',
  fx: 'parcels/block.parcels.parachute.png',
};

/*
  parcels block view
*/
export class ParcelsBlockView extends Container {
  public sprite: Sprite;
  private _enabled = true;

  public get enabled(): boolean {
    return this._enabled;
  }

  public set enabled(value: boolean) {
    // update field
    this._enabled = value;

    // update asset according to state
    this.sprite.texture = Texture.from(
      ParcelsBlockView.getManifest()[value ? 'enabled' : 'disabled'],
    );
  }

  constructor(props: ParcelsBlockProps) {
    super();
    this.sprite = Sprite.from(ParcelsBlockView.getManifest().enabled);
    this.addChild(this.sprite);
    this.sprite.anchorX = this.sprite.anchorY = 0.5;
    this.sprite.scaleX = this.sprite.scaleY = 0.6;
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return Object.values(this.getManifest());
  }

  private static getManifest() {
    // If new first 2 obstacle visuals is enabled, use crate assets instead
    if (features(user()).newFirst2ObstacleVisuals) {
      return cratesManifest;
    }

    return manifest;
  }
}
